import request from './api/request'
import utils from '@/utils/index'
import pfile from '@/utils/secretkey/pfile'
import sfile from '@/utils/secretkey/sfile'

var ak = utils.genak()
var ed = utils.re(ak, unescape(pfile)) //秘钥

function decrypt(data) {
  if (data?.ak) {
    let plaintext = utils.rd(data.ak, unescape(sfile))
    let obj = utils.secret(data.ed, plaintext, true)
    return JSON.parse(obj)
  } else {
    return data
  }
}

function inParameter(data) {
  if (data) {
    return { sn: ed, jt: utils.secret(data, ak) }
  } else {
    return data
  }
}
// 获取消息列表
export function getMsgList(data) {
  return request({
    url: '/userMsg/detailsList',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
// 点击消息
export function checkRed(data) {
  return request({
    url: '/center/readmsg',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
